<ng-container *transloco="let tr; prefix: 'productDefinitions'; scope: 'product-definitions'">
  <nz-affix [nzOffsetTop]="0">
    <nz-page-header [nzGhost]="false">
      <nz-page-header-title>{{ tr('title') }}</nz-page-header-title>
      <nz-page-header-subtitle>{{ tr('subTitle') }}</nz-page-header-subtitle>
      <nz-page-header-extra>
        <a routerLink="new" [queryParams]="{ tab: 'main' }" nz-button nzType="primary">
          <i nz-icon nzType="plus-circle" nzTheme="outline"></i> {{ 'button.addNew' | transloco}}
        </a>
      </nz-page-header-extra>
    </nz-page-header>
  </nz-affix>

  <nz-collapse nzBordered="false">
    <nz-collapse-panel [nzHeader]="'filters' | transloco" [nzActive]="true">
      <div nz-row [nzGutter]="[16,24]">
        <div nz-col>
          <small>{{tr('filter.brandId')}}</small>
          <hx-brand-select [(ngModel)]="filter.brandId" (selectChange)="onBrandChanged()"></hx-brand-select>
        </div>
        <div nz-col>
          <small>{{tr('filter.query')}}</small>
          <input nz-input [(ngModel)]="filter.query" (ngModelChange)="applyFilters(500)">
        </div>
        <div nz-col>
          <small>{{tr('filter.categoryIds')}}</small>
          <hx-product-category-select [(ngModel)]="filter.categoryIds" [brandId]="filter.brandId" [preload]="true" [hxMode]="'multiple'" (selectChange)="applyFilters()"></hx-product-category-select>
        </div>
      </div>
    </nz-collapse-panel>
  </nz-collapse>

  <nz-table [nzLoading]="isTableLoading" #listTable
            [nzTotal]="total"
            [nzPageSize]="limit"
            [nzPageIndex]="page"
            [nzData]="list"
            (nzQueryParams)="onQueryParamsChange($event)"
            [nzFrontPagination]="false">
    <thead>
    <tr>
      <th nzColumnKey="createDate">{{ tr('column.createDate') }}</th>
      <th nzColumnKey="title">{{ tr('column.title') }}</th>
      <th nzColumnKey="createDate">{{ tr('column.category') }}</th>
      <th nzColumnKey="type">{{ tr('column.type') }}</th>
      <th nzColumnKey="brand">{{ tr('column.brand') }}</th>
      <th nzWidth="100px">#</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of list">
      <td>{{ data.createDate | date: 'dd.MM.yyyy' }}</td>
      <td>
        <i nz-icon [nzType]="data.enabled ? 'check-circle': 'minus-circle'" [nzTwotoneColor]="data.enabled ? '#52c41a' : '#ff4d4f'" nzTheme="twotone"></i>
        {{ data.title | uiLabel }}
      </td>
      <td>{{ data.category?.title | uiLabel }}</td>
      <td>{{ 'enum.ProductInfoType.' + data.type | transloco }}</td>
      <td>{{ data.brand?.title }}</td>
      <td>
        <nz-button-group>
          <a [routerLink]="data.id + '/edit'" [queryParams]="{ tab: 'main' }" nz-button nzType="primary">
            <i nz-icon nzType="edit" nzTheme="outline"></i>
          </a>
          <a [routerLink]="data.id + '/sync'" nz-button nzType="primary">
            <i nz-icon nzType="sync" nzTheme="outline"></i>
          </a>
          <button nz-button nzType="default" nzDanger nz-popconfirm
                  [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                  [nzCancelText]="'no1' | transloco"
                  (nzOnConfirm)="remove(data.id)">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
          </button>
        </nz-button-group>
      </td>
    </tr>
    </tbody>
  </nz-table>
</ng-container>
